import React, { useState, useEffect, useRef } from 'react';
import TR from './../../Trans';
import Menu from '@mui/material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import searchStore from './../../stores/search';

function SearchListType(props) {

  const searchRef = useRef(null);

  const renderSearchList = () => {
    if (props.items) {
      return props.items.map((item, index) =>
        <MenuItem
          sx={{ background: index == props.suggestIndex ? "rgb(20,20,20)" : "none" }}
          disableAutoFocus={true}
          disableEnforceFocus={true}
          key={index}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              props.onSearch(item.value);
            }
          }}
          onClick={() => {
            props.onSearch(item.value);
          }}
        >
          <Stack direction="row" spacing={5}>
            <div style={{ paddingRight: "1rem" }}>
              <SearchIcon />
            </div>
            {item.value}
          </Stack>
        </MenuItem>
      );
    }
  };

  useEffect(() => {
    setTimeout(() => {
      let searchListContainer = document.getElementById(props.id);
      let searchField = document.getElementById(props.fieldId);
      if (props.open && searchField && searchListContainer) {
        let searchListPapers = searchListContainer.getElementsByClassName("MuiPaper-root");
        if (searchListPapers.length > 0) {
          let paper = searchListPapers[0];
          var rect = searchField.getBoundingClientRect();
          paper.style.top = (rect.top + 40) + "px";
          paper.style.maxHeight = (window.innerHeight - rect.top - 50) + "px";
        }
      }
    }, 100);
  }, [props.open]);

  return (
    <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus  
      id={props.id}
      ref={searchRef}
      className="muvika-search-list"
      open={props.open}
      onClose={props.onClose}
      anchorEl={props.anchorEl}
      autoFocus={false}
      disableAutoFocus={true}
      disableEnforceFocus={true}
    >
      {renderSearchList()}
    </Menu>
  );
}

export default SearchListType;